<template>
  <div>
    <div>
      <h1>Portal DDS Digital</h1>
      <!-- Modal de termos de uso  -->
      <div v-if="modalTermoOpen" class="new-card">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalTermoLabel">
                Termos de Uso
              </h5>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  {{ term.description }}
                  <h3 class="mt-3">Assinatura:</h3>
                  <div style="border: inset;">
                    <vue-signature ref="signature" id="signature" :options="option" :width="'auto'" :height="'auto'"
                      :disabled="disabled" :default-url="dataUrl">
                    </vue-signature>
                  </div>

                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="logout">
                Não aceito!
              </button>
              <button type="button" class="btn btn-primary" @click="handleAccept">
                Aceito!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalTermo" tabindex="-1" aria-labelledby="modalTermoLabel" aria-hidden="true"
      data-bs-keyboard="false" data-bs-backdrop="static" style="overflow-x:auto;">
    </div>

    <div class="ibox animated fadeInRightBig mt-2">
      <div class="ibox-title">Dashboard</div>
      <div class="mt-5 mb-5"
        style="background-color: white; display: flex; justify-content: space-between; padding: 0 15px;padding-bottom: 1%;">
        <div style="width: 25%;margin-left: 20%;">
          <label for="startDate" class="form-label">Data Inicial:</label>
          <input type="date" id="startDate" v-model="startDate" class="form-control" />
        </div>
        <div style="width: 25%;">
          <label for="endDate" class="form-label">Data Final:</label>
          <input type="date" id="endDate" v-model="endDate" class="form-control" />
        </div>

        <div style="width: 25%;">
          <button class="btn btn-primary mt-2" @click="fetchDashboardData">Pesquisar</button>
        </div>
      </div>

      <div class="ibox-content" style="min-height: 400px">
        <div class="row">
          <div class="col-md-9">
            <div class="card">
              <div class="card-header">
                <div class="card-title mb-2">
                  Participação dos Colaboradores
                  <br />
                  <span class="subtitle">Quantidade de Convites X Quantidade de Confirmações de
                    Presença</span>
                </div>
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <BarChart id="Chart1" class="centered" v-if="load" :chart-data="dashboard.chart1"
                      :options="options1" style="max-height:400px" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="row">
              <div class="col-md-12">Percentual de Participação</div>
              <div class="col-md-12">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Mês</th>
                      <th scope="col">Percentual</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="pct in dashboard.chart1.percentual" :key="pct.month">
                      <td scope="row" align="center">{{ pct.month }}</td>
                      <td>{{ pct.pc }}%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ibox-title mt-2">Dashboard</div>
      <div class="ibox-content" style="min-height: 400px">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <div class="card-title mb-2">
                  Ranking por Áreas
                  <span class="subtitle">Áreas com maior participação nas reuniões de DDS.</span>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <BarChart id="Chart1" class="centered" v-if="load" :chart-data="dashboard.chart2"
                      :options="options1" style="max-height:400px" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ibox-title mt-2">Dashboard</div>
      <div class="ibox-content" style="min-height: 400px">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <div class="card-title mb-2">
                  Ranking por Temas
                  <span class="subtitle">Temas com maior participação nas reuniões de DDS.</span>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <BarChart id="Chart" class="centered" v-if="load" :chart-data="dashboard.chart3"
                      :options="options1" style="max-height:400px" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "./Charts/BarChart.js";
import Datepicker from "vuejs-datepicker";
import vueSignature from "vue-signature";

export default {
  components: {
    BarChart,
    Datepicker,
    vueSignature,
  },
  data() {
    return {
      load: false,
      options1: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
            },
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
            },
          }],
        },
      },
      disabled: false,
      dataUrl: "",
      dashboard: {},
      modalTermoOpen: false,
      term: {},
      sendUser: {},
      startDate: null,  // Adicionado para armazenar a data inicial
      endDate: null,    // Adicionado para armazenar a data final
    };
  },
  methods: {
    async fetchDashboardData() {
      this.load = false;
      try {
        const api = this.$store.state.api + "dashboard";
        const response = await axios.post(api, {
          start_date: this.startDate,
          end_date: this.endDate
        });
        this.dashboard = response.data;
        this.load = true;
      } catch (error) {
        console.error('Erro ao buscar dados do dashboard:', error);
      }
    },
    handleAccept() {
      this.captureSignature();
      this.updatePolitics(this.sendUser);
    },
    captureSignature() {
      const canvas = document.querySelector('#signature canvas');
      if (canvas) {
        this.dataUrl = canvas.toDataURL('image/png');
        console.log("Signature Data URL:", this.dataUrl);
      } else {
        console.error("Canvas element not found");
      }
    },
    dataURLToBlob(dataUrl) {
      console.log(dataUrl);
      let arr = dataUrl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    async updatePolitics(sendUser) {
      let api = this.$store.state.api + "users/" + sendUser.id;
      let currentDate = new Date().toISOString().split('T')[0];
      let fd = new FormData();

      fd.append("name", sendUser.name);
      fd.append("email", sendUser.email);
      fd.append("registry", sendUser.registry);
      fd.append("shift_id", sendUser.shift_id);
      fd.append("role_id", sendUser.role_id);
      fd.append("team_id", sendUser.team_id);
      fd.append('userType', sendUser.userType);
      fd.append('user_branches', sendUser.user_branches ? sendUser.user_branches : '');

      let signatureBlob = this.dataURLToBlob(this.dataUrl);

      console.log(signatureBlob);
      if (!signatureBlob || signatureBlob.size <= 1808) {
        swal({
          title: "Assinatura necessária",
          text: "Por favor, adicione sua assinatura antes de prosseguir.",
          icon: "warning",
          button: "OK"
        });
        return;
      }

      fd.append('term_signature_photo', signatureBlob, 'signature.png');
      fd.append("term_accepted", 1);
      fd.append("term_accepted_at", currentDate);
      fd.append("_method", "PUT");

      try {
        await axios.post(api, fd);
        this.$message("Sucesso", `Informações guardadas com sucesso`, "success");
        this.modalTermoOpen = false;
        await this.fetchDashboardData();  // Atualize os dados do dashboard após a atualização dos dados do usuário
        window.location.reload();
      } catch (error) {
        this.errors = error.response.data;
        this.$message(null, this.errors, "error");
      }
    },
    logout() {
      let api = this.$store.state.api + "logout";
      axios.post(api).then((response) => {
        localStorage.removeItem("token");
        this.$router.push({ path: "/login" });
      }).catch((error) => {
        this.errors = error.response.data.errors;
        this.$message("Erro", "Erro ao realizar logout", "error");
      });
    },
    async bringData() {
      const api = this.$store.state.api + "me";
      try {
        const response = await axios.post(api);
        this.user = response.data;
        let firstLogin = this.user.term_accepted;
        this.sendUser = this.user;
        this.userMessagePolitics(firstLogin, this.sendUser);
        await this.fetchDashboardData();  // Atualize os dados do dashboard após trazer os dados do usuário
      } catch (error) {
        this.$message("Erro", error.response.data, "error");
      }
    },
    userMessagePolitics(firstLogin, sendUser) {
      if (firstLogin == 0) {
        const api = this.$store.state.api + "termsOfUses/latest";
        axios.get(api).then((response) => {
          if (response.data[0]) {
            this.term = response.data[0];
            this.sendUser = sendUser;
            this.modalTermoOpen = true;
          }
        }).catch((error) => {
          this.$message(null, "Não foi possível encontrar o termo de uso", "error");
        });
      }
    },
    async getDashboards() {
      await this.fetchDashboardData();  // Use o método fetchDashboardData para buscar e atualizar os dados do dashboard
    },
  },
  mounted() {
    this.getDashboards();
    this.bringData();
    this.modalTermo = new window.bootstrap.Modal(document.getElementById('modalTermo'));
  },
};
</script>


<style scoped>
.card-title {
  font-size: 16px !important;
  font-weight: bold;
}

.subtitle {
  font-size: 14px !important;
  font-style: italic;
  font-weight: 400;
}

.mt-2 {
  margin-top: 2rem;
}

.mt-3 {
  margin-top: 3rem;
}

.mb-2 {
  margin-bottom: 1rem;
}

.new-card {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue